import * as React from "react"
const IconMenu = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 24}
        height={props.height || 24}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke || "#414651"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth || 1.667}
            d="M3 12h18M3 6h18M3 18h18"
        />
    </svg>
)
export default IconMenu
